import type { UserType } from '@shared/index.js';
import { throwNever } from '@shared/utils/throwNever.js';

export const convertUserType = (userType: UserType | null) => {
  if (!userType) {
    return 'unknown';
  }

  switch (userType) {
    case 'doctor':
      return 'd';
    case 'nurse':
      return 'n';
    case 'pharmacist':
      return 'ph';
    case 'director':
      return 'dir';
    case 'patient':
      return 'p';
    case 'support':
      return 's';
    case 'supplier':
      return 'sp';
    default:
      return throwNever(userType);
  }
};
